import { useNewLeaversInvestorsController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewLeaversModal/NewLeaversSteps/NewLeaversInvestors/useNewLeaversInvestorsController';
import { DragAndDrop } from '@dealstack/frontend/shared/components/DragAndDrop/DragAndDrop';
import { InvestorsUploadInstructions } from '@dealstack/frontend/shared/components/InvestorsUploadInstructions/InvestorsUploadInstructions';
import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

import { NewLeaversInvestorsSummary } from './NewLeaversInvestorsSummary';
import { NewLeaversInvestorsTable } from './NewLeaversInvestorsTable/NewLeaversInvestorsTable';
import { EXCEL_SPREADSHEET_TYPE } from '@dealstack/shared/lib/common/business/excel';

interface Props {
	className?: string;
}

const NewLeaversInvestors = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();
	const newLeaversInvestorsController = useNewLeaversInvestorsController();
	const {
		onTemplateDownload,
		uploadInvestorsTemplate,
		investorsSummary,
		investorsList,
		setInvestorsList,
	} = newLeaversInvestorsController;

	return (
		<div className={className}>
			<InvestorsUploadInstructions />

			<NewLeaversInvestorsTable
				investorsList={investorsList}
				setInvestorsList={setInvestorsList}
			/>
			<DragAndDrop
				onTemplateDownload={onTemplateDownload}
				multiple={false}
				uploadFileRequest={uploadInvestorsTemplate}
				accept={{
					[EXCEL_SPREADSHEET_TYPE]: ['.xlsx'],
				}}
				invalidTypeMessage={tMipCreate('investors.invalid_file_type')}
			/>

			{investorsSummary?.investorsCount ? (
				<NewLeaversInvestorsSummary investorsSummary={investorsSummary} />
			) : null}
		</div>
	);
};
const Memoized = memo(NewLeaversInvestors);
const Styled = styled(Memoized)`
	${Expandable}, ${NewLeaversInvestorsTable} {
		margin-top: 1em;
	}

	${DragAndDrop}, ${NewLeaversInvestorsSummary} {
		margin-top: 2em;
	}
`;

export { Styled as NewLeaversInvestors };
